import { Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";

export default function AboutPage() {
  const [currentReview, setCurrentReview] = useState(0);

  const reviews = [
    {
      quote: "51每日大赛已经成为我们获取娱乐圈第一手资讯的重要渠道，爆料速度快、内容真实可靠，在行业内已经建立了很高的公信力。",
      source: "娱乐产业观察",
      role: "行业媒体",
    },
    {
      quote: "作为吃瓜群众，51每日大赛是我每天必刷的平台。从网红塌房到明星八卦，内容又猛又及时，比其他平台快太多了！",
      source: "资深吃瓜用户",
      role: "平台用户",
    },
    {
      quote: "我们与51每日大赛的合作非常愉快。他们专业的采编团队和严格的审核机制，保证了每一条爆料的质量和可信度。",
      source: "内容合作伙伴",
      role: "合作方",
    },
  ];

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51每日大赛",
    url: "https://www.51meiridasai.com/",
    description: "51每日大赛实时吃瓜爆料与黑料网，覆盖51每日大赛今日吃瓜、在线观看入口，追踪网红塌房现场猛料。",
    foundingDate: "2020",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "kefu@51mrdasai.com",
      availableLanguage: ["Chinese"],
    },
    sameAs: [
      "https://weibo.com/51meiridasai",
      "https://www.douyin.com/user/51meiridasai",
    ],
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "如何联系51每日大赛进行商务合作？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过发送邮件至hezuo@51mrdasai.com与我们取得联系，我们的商务团队将在1-2个工作日内回复。",
        },
      },
      {
        "@type": "Question",
        name: "51每日大赛的爆料信息来源可靠吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "51每日大赛拥有专业的采编团队和严格的信息审核机制。所有爆料在发布前都经过多渠道交叉验证，确保内容的真实性和可靠性。",
        },
      },
      {
        "@type": "Question",
        name: "如何向51每日大赛匿名投稿？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过发送邮件至tougao@51mrdasai.com进行匿名投稿。我们承诺严格保护爆料人隐私，绝不泄露任何个人信息。",
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于51每日大赛 | 品牌介绍与联系我们"
        description="51每日大赛是国内领先的每日大赛吃瓜爆料平台，专注网红塌房追踪、明星八卦爆料、娱乐猛料发布。了解我们的品牌故事、团队实力和商务合作方式。"
        keywords="51每日大赛,关于我们,吃瓜爆料平台,网红塌房,商务合作,联系我们"
        canonicalUrl="https://www.51meiridasai.com/about"
        schema={[organizationSchema, faqSchema]}
      />

      <div className="min-h-screen bg-background-50 font-sans">
        <Navbar />

        {/* Page Header */}
        <section className="pt-28 pb-8 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </section>

        {/* Brand Introduction - About Section */}
        <section className="pb-16">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-2/5">
                <span className="text-xs font-label text-foreground-500 uppercase tracking-wide bg-background-100 px-3 py-1 rounded-full">
                  关于 51每日大赛
                </span>
                <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-4 mb-4">
                  全网最专业的
                  <br />
                  吃瓜爆料平台
                </h1>
                <div className="w-16 h-1 bg-primary-500 rounded-full mb-6"></div>
                <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20office%20with%20warm%20ambient%20lighting%2C%20multiple%20monitors%20displaying%20news%20feeds%2C%20journalists%20working%20at%20minimalist%20desks%2C%20professional%20newsroom%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%2C%20soft%20shadows%2C%20sophisticated%20workspace%20design&width=600&height=750&seq=about-brand-image&orientation=portrait"
                    alt="51每日大赛编辑团队"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:w-3/5 flex flex-col justify-center">
                <div className="space-y-5 text-foreground-700 leading-relaxed">
                  <p className="text-lg">
                    51每日大赛成立于2020年，是国内领先的<strong>吃瓜爆料</strong>资讯平台。
                    我们致力于为亿万网民提供最快速、最真实、最劲爆的<strong>网红塌房</strong>和娱乐八卦爆料内容。
                  </p>
                  <p>
                    作为专业的<strong>每日大赛黑料网</strong>，我们拥有一支经验丰富的采编团队，
                    通过多渠道信息收集和严格的事实核查，确保每一条发布的内容都经得起检验。
                    从<strong>每日大赛吃瓜爆料</strong>到<strong>51每日大赛今日</strong>热点追踪，
                    我们全方位覆盖娱乐资讯的每一个角落。
                  </p>
                  <p>
                    我们的使命是让每一位吃瓜群众都能通过<strong>51每日大赛在线观看</strong>入口，
                    第一时间获取最有价值的娱乐资讯。无论是明星八卦、网红翻车还是社会奇闻，
                    <strong>吃瓜爆料入口</strong>24小时向您敞开。
                  </p>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-10">
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">2020+</div>
                    <div className="text-xs text-foreground-500 mt-1">成立至今</div>
                  </div>
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">50万+</div>
                    <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
                  </div>
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">100万+</div>
                    <div className="text-xs text-foreground-500 mt-1">日活吃瓜</div>
                  </div>
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">99%</div>
                    <div className="text-xs text-foreground-500 mt-1">用户口碑</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="text-center mb-12">
              <span className="text-xs font-label text-foreground-500 uppercase tracking-wide bg-background-50 px-3 py-1 rounded-full">
                核心优势
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-3">
                专业团队 · 极速爆料
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  icon: "ri-time-line",
                  title: "7×24 全天更新",
                  desc: "我们的编辑团队7×24小时不间断监控各大平台和线人渠道，确保每一条劲爆消息都能第一时间送达您的眼前，绝不错过任何精彩爆料。",
                },
                {
                  icon: "ri-search-eye-line",
                  title: "全网溯源",
                  desc: "每一条爆料都经过多重信息交叉验证和专业团队审核，确保内容真实可靠。我们不传谣、不信谣，只提供经过核实的真相。",
                },
                {
                  icon: "ri-mail-send-line",
                  title: "匿名投稿",
                  desc: "提供安全可靠的匿名投稿通道，严格保护爆料人隐私。无论您是想揭露真相还是分享独家内幕，51每日大赛都是您最值得信赖的平台。",
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                    <i className={`${feature.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reviews / Testimonials */}
        <section className="py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-2/5">
                <div className="rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20professional%20media%20certification%20and%20award%20ceremony%20scene%2C%20elegant%20golden%20trophy%20on%20a%20minimalist%20pedestal%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20sophisticated%20and%20prestigious%20atmosphere%2C%20cream%20and%20gold%20color%20palette&width=600&height=750&seq=about-review-image&orientation=portrait"
                    alt="51每日大赛荣誉认证"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:w-3/5 flex flex-col justify-center">
                <span className="inline-block text-xs font-label text-accent-700 bg-accent-100 px-3 py-1 rounded-full w-fit">
                  [媒体评价]
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3 mb-4">
                  业内口碑 · 值得信赖
                </h2>

                <div className="bg-background-100 rounded-2xl p-8 mb-6 relative">
                  <div className="text-6xl font-heading text-primary-200 absolute top-4 left-4 leading-none">
                    &ldquo;
                  </div>
                  <div className="relative z-10 pt-6">
                    <p className="text-lg text-foreground-700 leading-relaxed mb-6 font-heading">
                      {reviews[currentReview].quote}
                    </p>
                    <div className="flex items-center gap-1 mb-1">
                      <span className="w-5 h-0.5 bg-primary-400 rounded-full"></span>
                      <span className="text-sm font-label font-semibold text-foreground-900">
                        {reviews[currentReview].source}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-500">
                      {reviews[currentReview].role}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setCurrentReview((prev) => (prev === 0 ? reviews.length - 1 : prev - 1))}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-left-line"></i>
                  </button>
                  <button
                    onClick={() => setCurrentReview((prev) => (prev === reviews.length - 1 ? 0 : prev + 1))}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  <div className="flex items-center gap-1.5 ml-2">
                    {reviews.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentReview(i)}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          i === currentReview
                            ? "bg-primary-500 w-5"
                            : "bg-background-300 hover:bg-background-400"
                        }`}
                      ></button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="text-center mb-12">
              <span className="text-xs font-label text-foreground-500 uppercase tracking-wide bg-background-50 px-3 py-1 rounded-full">
                商务合作
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-3">
                期待与您携手
              </h2>
              <p className="text-foreground-600 mt-3 max-w-xl mx-auto">
                无论您是品牌方、内容创作者还是广告主，51每日大赛都欢迎与您开展多元化的合作
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-4">
                  <i className="ri-advertisement-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">广告投放</h3>
                <p className="text-sm text-foreground-600 mb-3">品牌曝光、软文推广、原生广告等多种形式</p>
                <span className="text-sm font-label text-primary-600">
                  ad@51mrdasai.com
                </span>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-4">
                  <i className="ri-shake-hands-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">内容合作</h3>
                <p className="text-sm text-foreground-600 mb-3">联合出品、内容授权、IP合作开发</p>
                <span className="text-sm font-label text-accent-600">
                  hezuo@51mrdasai.com
                </span>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 mx-auto mb-4">
                  <i className="ri-mail-send-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">爆料投稿</h3>
                <p className="text-sm text-foreground-600 mb-3">匿名投稿通道，严格保护爆料人隐私</p>
                <span className="text-sm font-label text-secondary-600">
                  tougao@51mrdasai.com
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-12 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-8 rounded-2xl bg-background-100 border border-background-200">
              <div>
                <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-1">
                  还有其他问题？
                </h3>
                <p className="text-sm text-foreground-600">
                  欢迎随时联系我们，我们将竭诚为您服务
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/"
                  className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-label font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-home-line"></i>
                  返回首页
                </Link>
                <a
                  href="mailto:kefu@51mrdasai.com"
                  className="px-6 py-2.5 bg-background-50 text-foreground-700 text-sm font-label rounded-full border border-background-300 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-mail-line"></i>
                  联系客服
                </a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}